export default __webpack_public_path__ + "static/media/203.f8a5e6f6.jpg";